import {
  Gamepad2,
  Camera,
  BookOpen,
  Presentation,
  Lightbulb,
  ChevronRight,
} from 'lucide-react';
import Link from 'next/link';

interface CategoryPillsProps {
  className?: string;
}

export default function CategoryPills({ className = '' }: CategoryPillsProps) {
  return (
    <div
      className={`relative top-[-34px] flex flex-col items-center gap-3 ${className}`}
    >
      <span className="text-xs font-medium text-gray-500 drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)] dark:text-gray-400">
        From creators across:
      </span>
      <div className="flex items-center justify-center gap-2">
        <div className="inline-flex items-center gap-2.5 rounded-2xl bg-white/50 px-4 py-2 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.03),0_2px_8px_rgba(0,0,0,0.05)] backdrop-blur-sm dark:bg-gray-900/30 dark:shadow-[inset_0_0_0_1px_rgba(255,255,255,0.03),0_2px_8px_rgba(0,0,0,0.2)]">
          <Link
            href="/products?categories=game-and-software-development"
            className="group flex items-center gap-2 rounded-xl bg-gradient-to-b from-white to-gray-50/95 px-3 py-1.5 text-gray-600 shadow-[0_1px_2px_rgba(0,0,0,0.06),inset_0_0_0_1px_rgba(0,0,0,0.03)] transition-all hover:translate-y-[-1px] hover:shadow-[0_4px_8px_rgba(0,0,0,0.08),inset_0_0_0_1px_rgba(0,0,0,0.05)] dark:from-gray-800/90 dark:to-gray-800/70 dark:text-gray-300 dark:shadow-[0_1px_2px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.03)] dark:hover:shadow-[0_4px_8px_rgba(0,0,0,0.3),inset_0_0_0_1px_rgba(255,255,255,0.05)]"
          >
            <Gamepad2 className="h-3.5 w-3.5 drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)] transition-colors group-hover:text-brand" />
            <span className="text-xs font-medium drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]">
              Gaming
            </span>
          </Link>

          <Link
            href="/products?categories=photography-and-video"
            className="group flex items-center gap-2 rounded-xl bg-gradient-to-b from-white to-gray-50/95 px-3 py-1.5 text-gray-600 shadow-[0_1px_2px_rgba(0,0,0,0.04),inset_0_0_0_1px_rgba(0,0,0,0.03)] transition-all hover:shadow-[0_2px_3px_rgba(0,0,0,0.06),inset_0_0_0_1px_rgba(0,0,0,0.05)] dark:from-gray-800/90 dark:to-gray-800/70 dark:text-gray-300 dark:shadow-[0_1px_2px_rgba(0,0,0,0.15),inset_0_0_0_1px_rgba(255,255,255,0.03)] dark:hover:shadow-[0_2px_3px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.05)]"
          >
            <Camera className="h-3.5 w-3.5 transition-colors group-hover:text-brand" />
            <span className="text-xs font-medium">Photography</span>
          </Link>

          <Link
            href="/products?categories=art-and-design%2Cbusiness-and-marketing%2Cproductivity-and-writing"
            className="group flex items-center gap-2 rounded-xl bg-gradient-to-b from-white to-gray-50/95 px-3 py-1.5 text-gray-600 shadow-[0_1px_2px_rgba(0,0,0,0.04),inset_0_0_0_1px_rgba(0,0,0,0.03)] transition-all hover:shadow-[0_2px_3px_rgba(0,0,0,0.06),inset_0_0_0_1px_rgba(0,0,0,0.05)] dark:from-gray-800/90 dark:to-gray-800/70 dark:text-gray-300 dark:shadow-[0_1px_2px_rgba(0,0,0,0.15),inset_0_0_0_1px_rgba(255,255,255,0.03)] dark:hover:shadow-[0_2px_3px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.05)]"
          >
            <BookOpen className="h-3.5 w-3.5 transition-colors group-hover:text-brand" />
            <span className="text-xs font-medium">Publishing</span>
          </Link>

          <Link
            href="/products?categories=productivity-and-writing"
            className="group flex items-center gap-2 rounded-xl bg-gradient-to-b from-white to-gray-50/95 px-3 py-1.5 text-gray-600 shadow-[0_1px_2px_rgba(0,0,0,0.04),inset_0_0_0_1px_rgba(0,0,0,0.03)] transition-all hover:shadow-[0_2px_3px_rgba(0,0,0,0.06),inset_0_0_0_1px_rgba(0,0,0,0.05)] dark:from-gray-800/90 dark:to-gray-800/70 dark:text-gray-300 dark:shadow-[0_1px_2px_rgba(0,0,0,0.15),inset_0_0_0_1px_rgba(255,255,255,0.03)] dark:hover:shadow-[0_2px_3px_rgba(0,0,0,0.2),inset_0_0_0_1px_rgba(255,255,255,0.05)]"
          >
            <Lightbulb className="h-3.5 w-3.5 transition-colors group-hover:text-brand" />
            <span className="text-xs font-medium">Coaching</span>
          </Link>
        </div>

        <Link
          href="/products"
          className="flex items-center gap-1 rounded-xl px-3 py-1.5 text-gray-400 transition-colors hover:translate-y-[-1px] hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
        >
          <span className="text-xs font-medium drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]">
            More
          </span>
          <ChevronRight className="ml-0.5 h-3.5 w-3.5 drop-shadow-[0_1px_1px_rgba(0,0,0,0.1)]" />
        </Link>
      </div>
    </div>
  );
}
